import React from 'react';

export const Container = props => {
    return (
        <div className={ `dashboard-container` }>
            { props.children }
        </div>
    );
}
 
export default Container;